<template>
  <span class="bulb" />
</template>

<style src="~/assets/styles/components/atomic/bulb.scss" lang="scss" />
